import type { SerpBannerId, SerpBannerRepeat, SerpBannerSlot, SerpBannersGrid } from '../model/types';

export interface SerpBannerQueueItem {
  id: SerpBannerId;
  repeat: SerpBannerRepeat;
}

export function getSerpBannerPositions({ anchor, step }: SerpBannersGrid, totalCards: number): number[] {
  const positions: number[] = [];

  for (let position = anchor; position <= totalCards; position += step) {
    positions.push(position);
  }

  return positions;
}

export function getSerpBannerSlots(
  queue: readonly SerpBannerQueueItem[],
  grid: SerpBannersGrid,
  totalCards: number,
): SerpBannerSlot[] {
  const positions = getSerpBannerPositions(grid, totalCards);
  const repeated = queue.filter((banner) => banner.repeat === 'repeat');

  return positions.flatMap((cardPosition, index) => {
    const banner = index < queue.length ? queue[index] : repeated[(index - queue.length) % repeated.length];

    return banner ? [{ cardPosition, bannerId: banner.id }] : [];
  });
}
